
export default class TopHeaderCode {

	public get logOutUrl(): string {
		return `${window.location.origin}/${window.location.pathname}?logout=true`;
	}

	public get homePageUrl(): string {
		return `${window.location.origin}/organisation/`;
	}
}
